<button type="button" [ngClass]="{'not-button': isbutton == 'not' }" class="btn btn-reg not-button" class="btn-sm mb-2">
    <!-- <fa-icon [icon]="icon"></fa-icon> {{label}} -->
    {{label}}
</button>